import alternative, {
    BlockVariantAlternativeProps,
} from "@store/Library/Components/Common/Block/variant/types/alternative";
import bordered, { BlockVariantBorderedProps } from "@store/Library/Components/Common/Block/variant/types/bordered";
import separated, { BlockVariantSeparatedProps } from "@store/Library/Components/Common/Block/variant/types/separated";

export enum BlockVariant {
    None = "None",
    Alternative = "Alternative",
    Bordered = "Bordered",
    Separated = "Separated",
}

export interface BlockVariantProps {
    alternative?: BlockVariantAlternativeProps;
    bordered?: BlockVariantBorderedProps;
    separated?: BlockVariantSeparatedProps;
}

export const variants: any = { alternative, bordered, separated };
export const variantsUsingVariantSide = [BlockVariant.Bordered, BlockVariant.Separated];
